import React from 'react'
import { withRouter } from 'react-router-dom'

import Header from '../../components/Header/Header'
import MainMenu from 'components/MainMenu'
import DashboardRoutes from '../../routes/Dashboard'

export default withRouter(props => (
  <div className='app'>
    <Header />
    <div
      className={`
        app-body
        ${!props.settings.isMainMenuOpen ? 'app-body--fixed' : ''}
      `}
    >
      <MainMenu isOpen={props.settings.isMainMenuOpen} />
      <main className='main'>
        <div className='full-percent-heigth'>
          <DashboardRoutes {...props} />
        </div>
      </main>
    </div>
  </div>
))
